// frontend/src/components/report/primitives/StatTile.js

// The "2xl font-bold tabular-nums number + xs muted label" pattern repeated
// at every stat site (reviews count, pagespeed scores, reputation windows).
export function StatTile({ value, label, color }) {
  return (
    <div>
      <div className="text-2xl font-bold tabular-nums" style={color ? { color } : undefined}>
        {value ?? "–"}
      </div>
      <div className="text-sm text-muted-foreground">{label}</div>
    </div>
  );
}
